import { Content } from 'antd/lib/layout/layout';
import { observer } from 'mobx-react';
import { Auth, Farm } from 'models';
import React from 'react';
import { Switch } from 'react-router-dom';
import { Layout } from 'syngenta-digital-cropwise-react-ui-kit';
import { APIState } from '../../models/APIState';
import { BrowserWarning } from './components/BrowserWarning';
import { SidebarMenu } from './components/Sidebar';
import TopNavBarV2 from './components/TopNavBar/TopNavBarV2';
import './styles.less';

type LayoutViewProps = {
  viewModel: Auth;
  routes: () => {};
  organizations: any[];
  selectedOrgId: string;
  selectedOrgName: string;
  farms: Farm[];
  selectedFarmName: string;
  unmappedResourcesStatus: string;
  setSelectedOrg: (orgId: string) => void;
};

const LayoutView = observer(
  ({
    viewModel,
    routes,
    organizations,
    selectedOrgId,
    selectedOrgName,
    farms,
    selectedFarmName,
    unmappedResourcesStatus,
    setSelectedOrg,
  }: LayoutViewProps) => {
    return (
      <Layout data-cy="topnavbar_container">
        {viewModel.status === 'SUCCESS' && !viewModel.deepAction && (
          <TopNavBarV2
            logoutHandler={viewModel.logout}
            selectOrg={setSelectedOrg}
            selectedOrgId={viewModel.activeOrganization?.id}
            selectedWorkspaceId={viewModel.activeOrganization?.workspace_id}
            changeUnitSystem={(unitSystem: string) => viewModel.changeUnitSystem(unitSystem)}
          />
        )}
        <Layout
          className={`sidebar-container ${viewModel.deepAction ? 'h-screen' : 'h-available'} flex`}
        >
          {viewModel.status === 'SUCCESS' && !viewModel.deepAction && (
            <SidebarMenu unmappedResourcesStatus={unmappedResourcesStatus as APIState} />
          )}
          <Content>
            <Switch>{routes()}</Switch>
          </Content>
        </Layout>
        <BrowserWarning />
      </Layout>
    );
  },
);

export default LayoutView;
